function initCurvedImageShowcase(section) {
  var track = section.querySelector(".curved-image-showcase-gallery-track");
  if (!track) return;

  var progressBar = section.querySelector("[data-progress-bar]");
  var slides = track.querySelectorAll(".curved-image-showcase-slide");
  var originalCount = slides.length / 3;
  var gap = parseFloat(getComputedStyle(track).gap) || 0;
  var oneSetWidth = 0;
  var isResetting = false;

  function calculateSetWidth() {
    oneSetWidth = 0;
    for (var i = 0; i < originalCount; i++) {
      oneSetWidth += slides[i].offsetWidth + gap;
    }
  }

  function updateProgress() {
    if (!progressBar || oneSetWidth <= 0) return;
    var posInSet = ((track.scrollLeft % oneSetWidth) + oneSetWidth) % oneSetWidth;
    var ratio = posInSet / oneSetWidth;
    var minWidth = originalCount > 0 ? 100 / originalCount : 100;
    progressBar.style.width = minWidth + ratio * (100 - minWidth) + "%";
  }

  function setInitialScroll() {
    calculateSetWidth();
    track.scrollLeft = oneSetWidth;
    updateProgress();
  }

  setInitialScroll();

  track.addEventListener("scroll", function () {
    if (isResetting) return;

    if (track.scrollLeft >= oneSetWidth * 2) {
      isResetting = true;
      track.scrollLeft -= oneSetWidth;
      requestAnimationFrame(function () {
        isResetting = false;
      });
    } else if (track.scrollLeft <= 0) {
      isResetting = true;
      track.scrollLeft += oneSetWidth;
      requestAnimationFrame(function () {
        isResetting = false;
      });
    }

    updateProgress();
  });

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setInitialScroll, 200);
  });

  /* Mouse drag for desktop */
  var isDragging = false;
  var startX = 0;
  var scrollStart = 0;

  track.addEventListener("mousedown", function (e) {
    isDragging = true;
    startX = e.pageX;
    scrollStart = track.scrollLeft;
    track.style.cursor = "grabbing";
    track.style.scrollSnapType = "none";
    e.preventDefault();
  });

  document.addEventListener("mousemove", function (e) {
    if (!isDragging) return;
    var dx = e.pageX - startX;
    track.scrollLeft = scrollStart - dx;
  });

  document.addEventListener("mouseup", function () {
    if (!isDragging) return;
    isDragging = false;
    track.style.cursor = "";
    track.style.scrollSnapType = "";
  });
}

function initHeadingReveal() {
  var headings = document.querySelectorAll('.curved-image-showcase-heading');
  if (!headings.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 1.0 });

  headings.forEach(function (heading) {
    observer.observe(heading);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('.curved-image-showcase[data-infinite-scroll="true"]')
    .forEach(function (el) {
      initCurvedImageShowcase(el);
    });
  initHeadingReveal();
});

document.addEventListener("shopify:section:load", function (event) {
  var el = event.target.querySelector(
    '.curved-image-showcase[data-infinite-scroll="true"]',
  );
  if (el) initCurvedImageShowcase(el);
});
